import ValueCard from './../components/ValueCard';
import Heading from './../components/Heading';
import DetailsHeading from './../components/DetailsHeading';
import { faBalanceScale, faLightbulb, faHandshake } from '@fortawesome/free-solid-svg-icons';

function ValueSection() {
  return (
    <section className='py-10'>
    <Heading name="Our Values and Principles" tstyle="text-center my-1"/>
    <div className='mt-4 px-10' >
      <DetailsHeading 
      name="At PocketLPO, our core values guide every decision we make:" 
      tstyle="my-1"
      />
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10 mx-10 mb-8">
        <ValueCard 
          icon={faBalanceScale} 
          heading="Integrity" 
          description="We uphold the highest ethical standards in all our interactions." 
        />
        <ValueCard 
          icon={faLightbulb} 
          heading="Innovation" 
          description="Leveraging technology to deliver smarter, faster, and more efficient legal solutions." 
        />
        <ValueCard 
          icon={faHandshake} 
          heading="Collaboration" 
          description="Partnering with clients to create customized legal strategies." 
        />
    </div>

    </section>
  );
}

export default ValueSection;
